module.exports = __webpack_public_path__ + "img/tshirtback.dce97732.png";